import styled from 'styled-components';
import { Select } from 'antd';

export const StyledSpan = styled.span`
  margin-left: ${({ theme }) => theme.spacing.space_4};
  display: inline-block;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.space_1};

  && .ant-select-selection-item {
    border: 1px !important;
    border-style: solid !important;
    padding-left: ${({ theme }) => theme.spacing.space_2} !important;
    padding-right: ${({ theme }) => theme.spacing.space_2} !important;
  }
`;
